/* eslint-disable no-console */


import axios from 'axios';
import router from '../router';

export default {
    logoff(state) {
        state.user = { username: '', password: '' };
    },
    async login(state, user) {
        let authUser;

        try {
            authUser = await axios.post('https://api.forcohen.com/nefroatlas/users/login', user);

        }catch(e){
            console.log(e);
        }

        if (authUser) {
            state.user = authUser.data;
            router.push({ path: '/home' });
        } else {
            state.user = { error: true };
        }
    },
    async register(state, user) {
        let authUser;

        try {
            authUser = await axios.post('https://api.forcohen.com/nefroatlas/users', user);
        }catch(e){
            console.log(e);
        }

        if (authUser) {
            state.user = authUser.data;
            router.push({ path: '/home' });
        } else {
            state.user = { error: true };
        }

    }
}
